<template>
  <div
    :class="{ 'page-container': routeName !== 'Booking System' }"
    style="display: flex; flex-direction: column; min-height: 100vh"
  >
    <Loading v-if="loading" />
    <Wrapper v-if="apidata && !loading && !hideHeader.includes(routeName)" />
    <router-view v-if="!loading && apidata" @getData="getData" />
  </div>
</template>
 
<script>
export default {
  data: function() {
    return {
      loading: true,
      routeName: null,
      hideHeader: ["Reports Embed"],
    };
  },

  methods: {
    getData: async function() {
      try {
        this.loading = true;

        const response = await this.$axios({
          method: "post",
          // https://pipedream.com/@esminbound/superior-press-tac-get-frontend-data-p_G6CrjOx/edit?e=2BbH39feCw4O6VKaMnmWL7Niw7W
          url: "https://eneanm5tbmgtm9w.m.pipedream.net",
          params: {
            contact_id:
              this.$route.query?.contact_id ??
              localStorage.getItem(this.$apikeyname),
            url: window.location.hostname,
          },
          data: {
            fetchOptionsIds: ["reason_complete", "reason_incomplete", "escalation_type__tac_wesbanco_"],
          },
        });

        if (this.$route.name === "Login" && response.data.me) {
          if (
            response.data.me.properties.tac_system
              ?.split(";")
              .includes(response.data.system.system_id)
          ) {
            // Log in user
            localStorage.setItem(
              this.$apikeyname,
              this.$route.query.contact_id
            );
            this.$store.state.apidata = response.data;
            this.$router.push("/dashboard");
          } else {
            throw new Error(
              "You do not have access to this system. Please login again."
            );
          }
        } else {
          this.$store.state.apidata = response.data;
        }

        document.title = `${this.$route.name} - ${this.apidata.system?.name}`;
        if (this.apidata.system.favicon_url) {
          const favicon = document.querySelector("link[rel~='icon']");
          favicon.href = this.apidata.system.favicon_url;
        }

        this.injectStyles();
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    injectStyles: function() {
      let style = document.createElement("style");
      style.type = "text/css";
      style.appendChild(document.createTextNode(""));
      this.styleNode = style.childNodes[0];
      document.head.appendChild(style);
      this.styleNode.textContent = `
      :root{
        --primary-color:${this.apidata.system.primary_color};
        --secondary-color:${this.apidata.system.secondary_color};
        }
      `;
    },
  },

  created: function() {
    // Get the current URL's hostname
    var currentURL = window.location.hostname;

    // Define the redirection URLs based on the current URL
    var redirectURLs = {
      'bmo.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=bmo',
      'comerica.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=comerica_globalscape',
      'glacierbank.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=glacier',
      'seacoast.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=seacoast',
      'fnbo.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=fnbo_2023',
      'huntington.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=huntington',
      'tactest.sp.esminbound.com': 'https://www.superiorpress.com/tac/booking?system=esm_test_1',
      'fnbo0.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=fnbo0',
      'demo.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=demo_1',
      'sunflower.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=sunflower_lockbox', 
      'lakeridge.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=lakeridge',
      'helpdesk.tacsuperior.com': 'https://www.superiorpress.com/tac/booking?system=rdc_helpdesk'
    };

    // Check if the current URL exists in the redirection URLs and is not 'helpdesk.tacsuperior.com'
    if (currentURL in redirectURLs) {
      var redirectURL = redirectURLs[currentURL];
      
      // Check if the redirect URL contains "/dashboard"
      if (redirectURL.includes('/dashboard')) {
        // Replace the base URL with the new base URL
        redirectURL = redirectURL.replace(
          'https://www.superiorpress.com/tac/booking',
          'https://www.superiorpress.com/tac/web-app/dashboard'
        );
      }
      
      // Redirect the user to the corresponding URL
      window.location.href = redirectURL;
    } else {
      this.getData();
    }
  },

  watch: {
    $route: {
      handler(to) {
        document.title = `${to?.name} - ${this.apidata.system?.name}`;
        this.routeName = this.$route.name;
      },
    },
  },
};
</script>
